import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {};

export const SeasonReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_ALL_SEASON_DATA:
      return { ...state, allSeasonData: payload };

    case ActionTypes.FETCH_ALL_SEASON_DATA:
      return { ...state, fetchedSeasonData: payload };

    default:
      return state;
  }
};
